import { component } from 'picoapp'

export default component((node, ctx) => {
  // console.log('desktop nav mounted')
  const subnavTriggers = node.querySelectorAll('.has-dropdown')
  const allSubnavs = node.querySelectorAll('.subnav-desktop')
  const anyDesktopLink = node.querySelectorAll('.subnav-desktop ul li a')
  const header = document.querySelector('.slater-header')
  const hide = (elem) => { elem.classList.remove('is-visible')}
  const show = (elem) => { elem.classList.add('is-visible')}

  // on hover show the subnav
  for (let i = 0; i < subnavTriggers.length; i++) { 

    let dropdown = subnavTriggers[i].nextElementSibling
    function adjustDropdownTop() { dropdown.style.top = (header.offsetHeight) + 'px' }
  
    subnavTriggers[i].addEventListener('mouseenter', () => {
      show(dropdown)
      show(subnavTriggers[i])
      adjustDropdownTop()
    })

    subnavTriggers[i].addEventListener('mouseleave', () => {
      hide(dropdown)
      hide(subnavTriggers[i])
    })
    
    for (let i = 0; i < allSubnavs.length; i++) { 
      if (allSubnavs[i].classList.contains('is-visible')) {
        allSubnavs[i].addEventListener('mouseleave', () => {
          hide(dropdown)
        })
      }
    }

    dropdown.addEventListener('mouseenter', () => {
      show(dropdown)
      show(subnavTriggers[i])
      adjustDropdownTop()
    })

    dropdown.addEventListener('mouseleave', () => {
      hide(dropdown)
      hide(subnavTriggers[i])
    })
  }

  // close the subnav on any nav link click
  for (let i = 0; i < anyDesktopLink.length; i++) {
    const link = anyDesktopLink[i];
    
    link.addEventListener('click', function() {
      // console.log('close nav!!')

      for (let i = 0; i < allSubnavs.length; i++) {
        let dropdown = allSubnavs[i].nextElementSibling
        const openSubNav = allSubnavs[i];
        hide(openSubNav)
        hide(dropdown)
      }
    })
  }

  return node => {
    // console.log('desktop nav unmounted')
  }
})
